<template>
  <div>
    <table-component
      :model="model"
    />
  </div>
</template>

<script>
import TableComponent from '@/dc-it/components/TableComponent.vue'
import Destination from '@/dc-it/models/Destination'

export default {
  name: 'DestinationsView',
  components: { TableComponent },
  data() {
    return {
      model: Destination,
    }
  },
}
</script>

<style scoped>

</style>
